<template>
  <AppProvider>
    <AppLayout :loggedIn="user.isLoggedIn">
      <RouterView v-if="user.isLoggedIn" />
      <div v-else>
        <n-flex justify="center" align="center" vertical>
          <p class="login-desc">
            Please sign in with your
            <n-gradient-text type="info"> Sequins.bio </n-gradient-text> account to continue.
          </p>
          <n-button class="login-button" type="primary" @click="msAuth.login()">
            Sign in with Sequins
          </n-button>
        </n-flex>
      </div>
    </AppLayout>
  </AppProvider>
</template>

<script setup>
import { onMounted } from 'vue'
import { RouterView } from 'vue-router'
import { useMSAuth } from '@/auth/msAuth'
import AppLayout from './components/AppLayout.vue'
import AppProvider from './components/AppProvider.vue'

const msAuth = useMSAuth()
const user = msAuth.getUser()

onMounted(async () => {
  await msAuth.handleRedirect()
})
</script>

<style scoped>
.login-desc {
  margin: 20px 0;
}
</style>
